<template>
  <div>
    <div v-if="selected.length > 50" class="bab-alert">
      <i class="fas fa-triangle-exclamation"></i>
      <span> Limite máximo de 50 itens!</span>
    </div>

    <div v-else>
      <ActionButtons :actions="actions" @confirm="confirm" />
    </div>

    <Modal :title="(actionSelected && actionSelected.description) || ''" :showValidation="false" :closeOnEsc="true"
      :closeButton="true" :width="preProcessModalWidth" :autoHeight="true"
      :onHideModal="cancelConciliationBeforeConfirm" v-if="showModal('conciliationDateBeforeConfirm')">
      <div class="actions-selected-conciliation-modal-content">
        <div v-if="showPreProcessComponent" class="actions-selected-pre-process-component">
          <component :is="preProcessComponent" :key="preProcessInstanceKey" v-model="optionSelected"
            @valid="onPreProcessValid" @hide-actions="onPreProcessHideActions"></component>
        </div>

        <div v-if="!preProcessActionsHidden" class="actions-selected-conciliation-modal-actions">
          <Button key="conciliation-cancel" title="Cancelar" type="danger" size="small"
            :clicked="cancelConciliationBeforeConfirm" />
          <Button key="conciliation-continue" title="Continuar" type="primary" size="small" :disabled="!preProcessValid"
            :clicked="continueToConfirm" />
        </div>
      </div>
    </Modal>


    <Modal title="Tem certeza que deseja executar?" :showValidation="false" :closeOnEsc="false" :closeButton="false"
      :width="600" :height="750" v-if="showModal('confirm')">
      <ActionlHeader :description="actionSelected.description" :total="selected.length" :done="selectedDone.length"
        :errors="errorCount" />

      <ActionItemList :selected="selected" :status="status" :errorsMap="errorsMap" @show-error="openErrorDetails" />

      <hr class="hr" />

      <ActionFooter :isFinished="isFinished" :processing="processing" :selected="selected" :errorCount="errorCount"
        :canGoBack="hasPreProcessComponent" @ok="ok" @cancel="hideModal" @finish="finished" @back="backToPreProcess" />
    </Modal>

    <Modal v-if="errorDetails.open" :title="`Falha — Item ${errorDetails.index + 1}`" :showValidation="false"
      :closeOnEsc="false" :closeButton="false" :width="520" :height="360">
      <ActionErrorContent :id="errorDetails.id" :index="errorDetails.index" :messages="errorsMap[errorDetails.id]"
        @close="closeErrorDetails" />
    </Modal>

    <Modal title="Selecione a opção desejada" :showValidation="false" :closeOnEsc="true" :closeButton="true"
      :width="600" :height="750" v-if="showModal('actionsOptions')">
      <ActionsOptions :actionSelected="actionSelected" v-model="optionSelected" />
    </Modal>
  </div>
</template>

<script>
import Button from "@/ui/forms/Button";
import DateTime from "@/ui/forms/DateTime";
import Modal from "@/ui/forms/Modal";
import ScrollBar from "@/ui/layout/ScrollBar.vue";

import ActionButtons from "@/ui//shared/actions/ActionButtons.vue";
import ActionlHeader from "@/ui/shared/actions/ActionHeader.vue";
import ActionsOptions from "@/ui/shared/actions/ActionsOptions.vue";
import ActionItemList from "./ActionItemList.vue";
import ActionErrorContent from "./ActionErrorContent.vue";
import ActionFooter from "./ActionFooter.vue";

import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "ActionsSelected",
  components: {
    Button,
    DateTime,
    Modal,
    ScrollBar,
    ActionButtons,
    ActionlHeader,
    ActionsOptions,
    ActionItemList,
    ActionErrorContent,
    ActionFooter,
  },
  props: {
    actions: { type: Array, default: () => [] },
    selected: { type: Array, default: () => [] },
  },
  data() {
    return {
      actionSelected: {},
      optionSelected: "",
      conciliationDate: "",
      preProcessValid: true,
      preProcessActionsHidden: false,
      preProcessInstanceKey: 0,
      conciliationDateFormName: "actionsSelectedConciliationDateForm",
      selectedDone: [],
      processing: false,
      status: {},
      errorsMap: {},
      errorDetails: { open: false, id: null, index: -1 },
      errorIds: [],
      idsToProcess: [],
      isRetryFlow: false,
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal"]),
    errorCount() {
      return Object.values(this.status).filter((s) => s === "error").length;
    },
    preProcessComponent() {
      return this.actionSelected?.preProcessComponent || this.actionSelected?.component || null;
    },
    hasPreProcessComponent() {
      return !!this.preProcessComponent;
    },
    showPreProcessStep() {
      return this.hasPreProcessComponent
    },
    showPreProcessComponent() {
      return this.hasPreProcessComponent;
    },
    preProcessModalTitle() {
      if (this.actionSelected?.preProcessModalTitle) {
        return this.actionSelected.preProcessModalTitle;
      }
      return "Pré-processamento";
    },
    preProcessModalWidth() {
      return this.actionSelected?.preProcessModalWidth || 600;
    },
    isFinished() {
      if (!this.selected.length) return false;
      const statuses = Object.values(this.status);
      return (
        statuses.length === this.selected.length &&
        statuses.every((s) => s === "done" || s === "error")
      );
    },
  },
  methods: {
    ...mapActions("generic", ["putApi", "deleteAllApi", "postApi"]),
    ...mapMutations("generic", [
      "openModal",
      "hideModal",
      "executedSearch",
      "addSelected",
      "addEvent",
    ]),
    confirm(params) {
      this.actionSelected = params;
      this.selectedDone = [];
      this.processing = false;
      this.status = {};
      this.errorsMap = {};
      this.errorIds = [];
      this.idsToProcess = [...this.selected];
      this.isRetryFlow = false;
      this.optionSelected = "";
      this.conciliationDate = "";
      this.preProcessValid = true;
      this.preProcessActionsHidden = false;
      this.preProcessInstanceKey++;
      this.selected.forEach((id) => this.$set(this.status, id, "waiting"));

      if (params.type == "options") {
        this.openModal("actionsOptions");
      } else if (this.showPreProcessStep) {
        this.openModal("conciliationDateBeforeConfirm");
      } else {
        this.openModal("confirm");
      }
    },
    continueToConfirm() {
      if (this.hasPreProcessComponent && !this.preProcessValid) return;
      this.hideModal("conciliationDateBeforeConfirm");
      this.openModal("confirm");
    },
    onPreProcessValid(value) {
      this.preProcessValid = !!value;
    },
    onPreProcessHideActions(value) {
      this.preProcessActionsHidden = !!value;
    },
    cancelConciliationBeforeConfirm() {
      this.conciliationDate = "";
      this.optionSelected = "";
      this.hideModal("conciliationDateBeforeConfirm");

      if (this.isRetryFlow) {
        this.openModal("confirm");
        return;
      }

      this.addEvent({ name: "actionsUpdated" });
    },
    backToPreProcess() {
      this.idsToProcess = [...this.errorIds];
      this.idsToProcess.forEach((id) => {
        this.$set(this.status, id, "waiting");
        this.$delete(this.errorsMap, id);
      });
      this.errorIds = [];
      this.isRetryFlow = true;
      this.preProcessInstanceKey++;
      this.preProcessValid = true;
      this.preProcessActionsHidden = false;
      this.hideModal("confirm");
      this.openModal("conciliationDateBeforeConfirm");
    },
    buildPayload(id) {
      const payload = { id: id, ...(this.actionSelected.payload || {}) };
      if (this.optionSelected !== null && this.optionSelected !== undefined && this.optionSelected !== "") {
        if (typeof this.optionSelected === "object" && !Array.isArray(this.optionSelected)) {
          Object.assign(payload, this.optionSelected);
        } else {
          payload.any = this.optionSelected;
        }
      }

      return payload;
    },
    async put(id) {
      const payload = this.buildPayload(id);

      const response = await this.putApi({
        url: this.actionSelected.url,
        obj: payload,
        notNotifyToast: true,
      });
      return response;
    },
    async remove(id) {
      const response = await this.deleteAllApi({
        url: this.actionSelected.url,
        selected: [id],
        notNotifyToast: true,
      });
      return response;
    },
    async post(id) {
      let payload = this.buildPayload(id);
      if (this.actionSelected.type === "delete") {
        const { id: removedId, ...rest } = payload;
        payload = { ids: [removedId], ...rest };
      }
      const response = await this.postApi({
        url: this.actionSelected.url,
        obj: payload,
        notNotifyToast: true,
      });
      return response;
    },
    async ok() {
      if (this.processing) return;
      this.processing = true;

      for (let i = 0; i < this.idsToProcess.length; i++) {
        const id = this.idsToProcess[i];
        this.$set(this.status, id, "running");

        try {
          let result = null;
          if (this.actionSelected.method == "delete")
            result = await this.remove(id);

          if (this.actionSelected.method == "put") result = await this.put(id);
          if (this.actionSelected.method == "post") result = await this.post(id);

          if (result?.success) {
            this.$set(this.status, id, "done");
            this.selectedDone.push(id);
          } else {
            const msgs = (result?.notifications || [])
              .map((n) => n && n.message)
              .filter(Boolean)
              .map((m) => `Erro: ${m}`);
            this.$set(this.errorsMap, id, msgs.length ? msgs : ["Erro: Falha ao processar item."]);
            this.$set(this.status, id, "error");
            this.errorIds.push(id);
          }
        } catch {
          this.$set(this.errorsMap, id, [
            "Erro: Falha inesperada ao comunicar com a API.",
          ]);
          this.$set(this.status, id, "error");
          this.errorIds.push(id);
        }
      }

      this.processing = false;
    },
    openErrorDetails({ id, index }) {
      this.errorDetails = { open: true, id, index };
    },
    closeErrorDetails() {
      this.errorDetails = { open: false, id: null, index: -1 };
    },
    finished() {
      this.hideModal();
      this.isRetryFlow = false;

      if (this.errorIds.length > 0) {
        this.addSelected(this.errorIds);
      } else {
        this.addEvent({ name: "deselectAll" });
      }

      this.executedSearch();
    },
  },
};
</script>

<style scoped>
.bab-alert {
  box-sizing: border-box;
  margin-bottom: 10px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  padding: 8px 15px;
  border-radius: 10px;
  background-color: #fff1f0;
  border: 1px solid #ffa39e;
}

.bab-alert i {
  color: #dc2626;
  font-size: 15px;
}

.hr {
  margin: 14px 0;
  border: none;
  border-top: 1px solid #eef2f7;
}

.actions-selected-conciliation-date {
  margin-bottom: 12px;
}

.actions-selected-conciliation-modal-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.actions-selected-pre-process-component {
  margin-bottom: 4px;
}

.actions-selected-conciliation-modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
</style>
